<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col cols="12">
        <loading-spinner />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card>
            <v-tabs 
            v-model="tab" 
            bg-color="primary"
            grow
            >

            <v-tab :key="tabs.review.id"  v-if="finalReview && finalReview.status === 'COMPLETED'">{{  $t('tabs.paper_review')  }}</v-tab>
                    <v-tab-item :key="tabs.review.id" v-if="finalReview && finalReview.status === 'COMPLETED'">
                        <v-card flat>
                            <v-card-text>   
                                <show-paper-review :final-review="finalReview"></show-paper-review>
                            </v-card-text>
                        </v-card>
                </v-tab-item>

                <v-tab :key="tabs.author.id">{{  $t('tabs.author')  }}</v-tab>
                <v-tab-item :key="tabs.author.id">
                    <v-card flat>
                        <v-card-text>   
                            <submit-author :readonly="contentReadonly" :authors="paper.authors"></submit-author>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab :key="tabs.content.id">{{ $t('tabs.paper_content') }}</v-tab>
                <v-tab-item :key="tabs.content.id">
                    <v-card flat>
                        <v-card-text>   
                            <write-paper-content :readonly="contentReadonly" :paper="paper"></write-paper-content>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
    
    import SubmitAuthor from '@/components/specific/Submission/SubmitAuthor.vue';
    import ShowPaperReview from '@/components/specific/Submission/ShowPaperReview.vue';
    import WritePaperContent from '@/components/specific/Submission/WritePaperContent.vue';

    import { submissionDetailTabs } from "@/fields/paper/tabs";
    import { submissionPaperDetailFields } from "@/fields/paper/fields";

    import { paperApi, finalReviewApi } from '@/api/api';


    export default {
        components: {
            LoadingSpinner,
            SubmitAuthor,
            WritePaperContent,
            ShowPaperReview,
        },
        props: {
            idx: {
                type: [Number, String],
                required: true,
            },
        },
        data() {
            return {
                tab: null,
                tabs: submissionDetailTabs,
                paperDetailFields: submissionPaperDetailFields,
                contentReadonly: true,
                isLoading: false,
                paper: {
                  idx: null,
                  journal: {
                    idx: null,
                    title: "",
                  },
                  title_ko: "",
                  title_en: "",
                  keyword_kor: "",
                  keyword_eng: "",
                  abstract_kor: "",
                  abstract_eng: "",
                  authors: [],
                  category: null,
                  status: null,
                },
                finalReview: null,
            }
        },
        methods: {
            toSubmissionStatus() {
                this.$router.push({
                    name: "submission-status"
                });
            },
            /**
             * ****************************************************************************************
             * Paper
             * ****************************************************************************************/
            async fetchPaper() {
                try {
                    this.isLoading = true;
                    const params = {
                    idx: this.idx,
                    }

                    const response = await paperApi.getPaper(params);

                    if (response && response.status === 200) {
                    this.paper = response.data.response;
                    return true;
                    }
                    return false;
                } catch {
                    return false;
                } finally {
                    this.isLoading = false;
                }
            },
            /**
             * 총평 상세 데이터 api 요청
             */
            async fetchReviewByPaper() {
                try {
                    this.isLoading = true;
                    let paper_idx = this.paper.idx;
                    
                    if (this.paper.category == "REVISION" && this.paper.status != "COMPLETED") {
                        paper_idx = this.paper.parent_idx;
                    }

                    const params = {
                        paper_idx: paper_idx,
                    }
                    const response = await finalReviewApi.showFinalReviewByPaper(params);
                        
                    if (response && response.status == 200) {
                        this.finalReview = response.data.response;
                    } else {
                        this.notifyVue({alertMessage: this.$t('alert.failed_request'), color: 'danger'});
                    }
                } catch (error) {
                    this.notifyVue({alertMessage: this.$t('alert.failed_request'), color: 'danger'});
                } finally {
                    this.isLoading = false;
                }
            },

            /* ****************************************************************************************
            * 알럿
            * ****************************************************************************************/
            notifyVue({
                vertical = "top",
                horizontal = "right",
                message = "",
                style = "primary",
                icon = "priority_high",
            } = {}) {
                this.$notify({
                    timeout: 8000,
                    message: message,
                    icon: icon,
                    type: style,
                    horizontalAlign: horizontal,
                    verticalAlign: vertical,
                });
            }
        },
        async mounted() {
            if (this.idx == null) {
                this.toSubmissionStatus();
            }
            await this.fetchPaper();
            await this.fetchReviewByPaper();
        },
    }
</script>

<style scoped></style>
